import React from 'react'
import { Button, DialogActions, DialogTitle, Grid, Icon, IconButton } from '@mui/material'
import PropTypes from 'prop-types'
import SaveIcon from '@mui/icons-material/Save'

const BasicDialogTitle = ({
    onClose = () => {},
    children = '',
}) => (
    <DialogTitle>
        <Grid container justifyContent='space-between' alignItems='center'>
            <Grid size='grow'>
                {children}
            </Grid>
            <Grid size='auto'>
                <IconButton onClick={onClose} sx={{ fontSize: '2rem' }}>
                    <Icon sx={{ color: 'white', fontSize: 'inherit' }}>close</Icon>
                </IconButton>
            </Grid>
        </Grid>
    </DialogTitle>
)

BasicDialogTitle.propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.any,
}

const BasicDialogAction = ({
    onValidate = () => {},
    isLoading = false,
    isDisabled = false,
    buttonLabel = 'Valider',
    children,
}) => (
    <DialogActions>
        <Grid container alignItems='center' justifyContent='space-between' spacing={2} sx={{ width: '100%' }}>
            <Grid size='grow'>
                {children}
            </Grid>
            <Grid size='auto'>
                <Button
                    onClick={onValidate}
                    variant='contained'
                    color='primary'
                    loading={isLoading}
                    loadingPosition='start'
                    startIcon={<SaveIcon />}
                    disabled={isDisabled}
                >
                    {buttonLabel}
                </Button>
            </Grid>
        </Grid>
    </DialogActions>
)

BasicDialogAction.propTypes = {
    onValidate: PropTypes.func,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    buttonLabel: PropTypes.string,
    children: PropTypes.any,
}

export {
    BasicDialogTitle,
    BasicDialogAction,
}